<template>
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <h4 class="page-header">
          <b-icon icon="wallet-plus"></b-icon>
          <span>{{ $ml.get('payment_deposit') }}</span>
        </h4>
      </div>
    </div>
    <form @submit.prevent="submit" novalidate>
      <b-loading :is-full-page="false" v-model="loading" :can-cancel="false"></b-loading>
      <div class="columns is-centered">
        <div class="column is-4">
          <b-field
              :label="$ml.get('payment_amount') + '*'"
              :message="'amount' in errors ? errors['amount'] : $ml.get('payment_amount_range')"
              :type="'amount' in errors ? 'is-danger' : ''">
            <b-input v-model="form.amount" icon="cash"></b-input>
          </b-field>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-2">
          <b-radio v-model="form.pay_system" native-value="QIWI">
            <svg xmlns="http://www.w3.org/2000/svg" width="87" height="32" viewBox="0 0 87 32">
              <path fill="#FF8C00" fill-rule="evenodd" d="M21.571 27.814c2.709 0 5.648.927 8.902 3.804.326.288.76-.07.475-.428-3.197-4.029-6.154-4.796-9.103-5.444-3.608-.794-5.463-2.82-6.756-5.044-.257-.442-.373-.364-.396.205-.029.695.02 1.616.176 2.522-.146.006-.292.005-.44.005-5.16 0-9.344-4.176-9.344-9.327 0-5.15 4.184-9.325 9.345-9.325 5.16 0 9.344 4.175 9.344 9.325 0 .367-.018.73-.06 1.085-.682-.123-2.025-.137-2.967-.056-.354.031-.304.196-.036.244 3.089.557 5.21 2.468 5.696 5.935.01.08.116.103.157.034a14.02 14.02 0 0 0 2.001-7.242C28.565 6.317 22.236 0 14.43 0 6.623 0 .294 6.316.294 14.107c0 7.792 6.329 14.109 14.136 14.109 2.07 0 4.126-.402 7.141-.402zm1.052-5.122c.629.53.82 1.161.488 1.606-.185.244-.485.379-.845.379a1.5 1.5 0 0 1-.961-.348c-.572-.499-.74-1.307-.367-1.766.146-.18.383-.279.667-.279.345 0 .707.145 1.018.408zm2.902-1.348c.092.618-.103.874-.3.874-.215 0-.484-.25-.801-.745-.314-.488-.429-1.048-.273-1.331.102-.187.317-.269.588-.166.525.197.73.999.786 1.368zm19.594-3.23l-1.63-1.957a.315.315 0 0 1 .244-.516h3.409c.162-.482.254-.997.254-1.533 0-2.45-1.828-4.563-4.336-4.563s-4.336 2.113-4.336 4.563c0 2.45 1.828 4.534 4.336 4.534.76 0 1.456-.194 2.06-.529zm7.374 3.305c.177.196.032.51-.235.51h-3.72a.51.51 0 0 1-.392-.183l-.63-.757a8.174 8.174 0 0 1-4.456 1.316c-4.529 0-8.213-3.677-8.213-8.197s3.684-8.197 8.213-8.197c4.529 0 8.213 3.677 8.213 8.197 0 1.63-.48 3.148-1.305 4.426l2.525 2.885zM86.862 6.29h-3.037a.404.404 0 0 0-.403.403v14.833c0 .223.18.403.403.403h3.037c.223 0 .404-.18.404-.403V6.692a.404.404 0 0 0-.404-.404zm-5.11 0h-3.396a.404.404 0 0 0-.387.283l-2.688 8.766-2.955-8.776a.403.403 0 0 0-.383-.274h-2.37a.404.404 0 0 0-.384.274l-2.954 8.776-2.688-8.766a.404.404 0 0 0-.387-.284h-3.397a.405.405 0 0 0-.327.167.396.396 0 0 0-.056.36l4.99 14.841c.055.164.21.274.383.274h2.696c.174 0 .328-.11.383-.273l2.926-8.671 2.925 8.67c.055.164.21.274.383.274h2.697c.174 0 .328-.11.383-.274l4.99-14.841a.398.398 0 0 0-.055-.36.406.406 0 0 0-.328-.167zm-23.658.403v14.833c0 .223-.18.403-.404.403h-3.036a.404.404 0 0 1-.404-.403V6.692c0-.223.18-.404.404-.404h3.036c.223 0 .404.18.404.404z"/>
            </svg>
          </b-radio>
        </div>
        <div class="column is-2">
          <b-radio v-model="form.pay_system" native-value="PAYKASSA">
            <img alt="USDT" title="USDT" src="../assets/tether.png" style="height: 32px">
          </b-radio>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button :disabled="form.amount === '' || form.amount < 1" type="is-info" native-type="submit">
            {{ $ml.get('payment_make_deposit') }}
          </b-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Payment",
  data() {
    return {
      loading: false,
      errors: [],
      form: {
        amount: '',
        pay_system: 'QIWI'
      }
    }
  },
  computed: {},
  methods: {
    submit: function () {
      this.loading = true
      this.errors = []
      Vue.prototype.$http.post(process.env.VUE_APP_API_HOST + 'payment/v2', {payment: this.form}).then(resp => {
        window.location = resp.data.result
      }).catch(err => {
        if (err.response.status === 400) {
          this.errors = err.response.data.result
        } else {
          this.flashMessage.error({
            title: this.$ml.get('common_request_failed'),
            message: this.$ml.get('common_request_failed_message'),
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
  mounted() {
  },
  metaInfo() {
    return {
      title: this.$ml.get('titles_payment')
    }
  }
}
</script>

<style scoped>
</style>